'use strict'

/**
 * @enum InspectionParameterType
 */
let InspectionParameterType;
(function (inspectionParameterType) {
  inspectionParameterType.None = 0
  inspectionParameterType[0] = 'None'

  inspectionParameterType.G4 = 1
  inspectionParameterType[1] = 'G4'

  inspectionParameterType.G6 = 2
  inspectionParameterType[2] = 'G6'  

  inspectionParameterType.G10 = 3
  inspectionParameterType[3] = 'G10'

  inspectionParameterType.G16 = 4
  inspectionParameterType[4] = 'G16'
  
  inspectionParameterType.G25 = 5
  inspectionParameterType[5] = 'G25'

  inspectionParameterType.G40 = 6
  inspectionParameterType[6] = 'G40'

  inspectionParameterType.G65 = 7
  inspectionParameterType[7] = 'G65'

  inspectionParameterType.G100 = 8
  inspectionParameterType[8] = 'G100'

})(InspectionParameterType || (InspectionParameterType = {}))

export { InspectionParameterType }